<template>
    <div v-if="news">
        <div
            class="news my-32 dark:bg-[#293340] bg-[#FFFFFD] flex flex-col mx-auto gap-7 px-4 sm:px-6 lg:px-8 items-center max-w-[1200px]">
            <h1 class="text-2xl sm:text-3xl md:text-4xl text-primary my-7">{{ news.title }}</h1>
            <!-- عرض الصورة -->
            <div class="w-full flex flex-col items-center justify-center">
                <img class="w-full max-w-xl sm:max-w-sm md:max-w-lg lg:max-w-4xl" loading="lazy" :src="news.image"
                    :alt="news.title">
                <p class="self-center dark:text-white opacity-70 text-sm sm:text-base lg:max-w-3xl mt-2">
                    {{ news.date }}
                </p>
            </div>
            <p class="text-lg sm:text-xl md:text-2xl text-secondary dark:text-white opacity-90 max-w-[600px] text-center mt-4">
                {{ news.subtitle }}
            </p>
            <div 
                class="text-sm sm:text-base md:text-lg max-w-[800px] dark:text-white opacity-50 text-start mt-2 markdown-content"
                v-html="parsedDescription"
            ></div>
        </div>

        <!-- عرض آخر 3 أخبار تمت إضافتها -->
        <div class="latest-news my-10 max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 ">
            <h2 class="text-xl sm:text-2xl md:text-3xl text-primary mb-5"> {{ t(`news.title`) }} </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 ">
                <div v-for="item in latestNews" :key="item.id" class="bg-white dark:bg-[#293340] news text-start shadow-md p-4 rounded-md">
                    <img :src="item.image" :alt="item.title" class="w-full h-auto mb-2 rounded" />
                    <h3 class="text-lg sm:text-xl font-semibold text-primary">
                        {{ item.title }}
                    </h3>
                    <router-link :to="`/news/${item.id}`" class="text-secondary dark:text-white hover:underline hover:text-primary mt-4 inline-block">
                        {{ t(`buttons.learnMore`) }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <div>
            <LandingScreen />
        </div>
    </div>
</template>

<script setup>
import LandingScreen from './master/LandingScreen.vue';
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { BASE_URL } from '@/config'
import { useI18n } from 'vue-i18n'
import { marked } from 'marked'; // أضف هذه الاستيرادة
import { computed } from 'vue'; // أضف هذه الاستيرادة

const news = ref(null)
const latestNews = ref([]) // متغير لتخزين آخر 3 أخبار
const route = useRoute()
const { t, locale } = useI18n()

// دالة لجلب تفاصيل الخبر
const fetchData = async () => {
    const newsId = route.params.id
    try {
        const response = await fetch(`${BASE_URL}/news/${newsId}`, {
            headers: {
                'Accept-Language': locale.value,
            }
        })

        if (!response.ok) throw new Error('Failed to fetch news details.')

        const data = await response.json()
        news.value = data.data
    } catch (error) {
        console.error('Error fetching news:', error)
    }
}

// دالة لجلب آخر 3 أخبار
const fetchLatestNews = async () => {
    try {
        const response = await fetch(`${BASE_URL}/news?limit=3`, {
            headers: {
                'Accept-Language': locale.value,
            }
        })

        if (!response.ok) throw new Error('Failed to fetch latest news.')

        const data = await response.json()
        latestNews.value = data.data
    } catch (error) {
        console.error('Error fetching latest news:', error)
    }
}

onMounted(() => {
    fetchData().then(() => {
        fetchLatestNews()
    })
})

watch(locale, () => {
    fetchData()
    fetchLatestNews()
})

// مراقبة تغير رقم الخبر في المسار
watch(() => route.params.id, () => {
    news.value = null
    fetchData()
    fetchLatestNews()
})


const parsedDescription = computed(() => {
  return news.value?.description ? marked(news.value.description) : '';
});
</script>

<style scoped>
.markdown-content :deep(ul) {
    list-style-type: disc;
    padding-left: 1.5rem;
}

.markdown-content :deep(li) {
    margin-bottom: 0.5rem;
}

.markdown-content :deep(strong) {
    font-weight: bold;
    color: currentColor;
}

.markdown-content :deep(a) {
    color: #BB936A;
    text-decoration: underline;
}

.markdown-content :deep(em) {
    font-style: italic;
}
  
.news {
    box-shadow: 1px 3px 35px 0px #293340;
    padding: 20px;
    text-align: start;
}

.dark .news {
    box-shadow: 1px 3px 35px 0px #BB936A;
}

/* تخصيص للهواتف */
@media (max-width: 640px) {
    .news {
        border-radius: 5px;
        padding: 10px;
        margin: 110px 14px;
    }
}
</style>
